import React from 'react';
import { Button } from '../ui/button';
import { Label } from '../ui/label';
import { FiatCurrency } from '../../lib/typicalV2';

export const MerchantCurrencySelector: React.FC<{
    value: FiatCurrency;
    onChange: (currency: FiatCurrency) => void;
}> = ({ value, onChange }) => (
    <div className="space-y-2">
        <Label>Фиатная валюта</Label>
        <div className="flex gap-2">
            {(['RUB', 'KGS', 'KZT'] as const).map((currency) => (
                <Button
                    key={currency}
                    type="button"
                    size="sm"
                    variant={value === currency ? 'default' : 'outline'}
                    aria-pressed={value === currency}
                    onClick={() => onChange(currency)}
                >
                    {currency} / USDT
                </Button>
            ))}
        </div>
        <p className="text-xs text-green-600 dark:text-green-300">Валюта фиксируется после регистрации мерчанта.</p>
    </div>
);
